/**
 * Generate a list of numbers, in descending order
 * E.g. (2025, 5) -> [2025, 2024, 2023, 2022, 2021]
 * E.g. (2024, 3) -> [2024, 2023, 2022]
 *
 * @param start Generate numbers starting from the here
 * @param count Number of numbers to geneate
 * @returns
 */
export function generateDescendingRange(start: number, count: number) {
  return [...Array(count).fill(start)].map((_, i) => start - i);
}

/**
 * Generate a list of pairs of numbers, in descending order
 * E.g. (2024, 5) -> [[2024, 2025], [2023, 2024], [2022, 2023], [2021, 2022], [2020, 2021]]
 * E.g. (2021, 3) -> [[2023, 2024], [2022, 2023], [2021, 2022]]
 *
 * @param start Generate pairs from the given number
 * @param count Number of pairs to generate
 * @returns
 */
export function generateDescendingPairsRange(start: number, count: number) {
  return [...Array(count).fill(start)].map((_, i) => [
    start - 1 - i,
    start - i
  ]);
}
